import { awsApiInstance } from '../api/aws-api';
import useAuth from '../hooks/auth-hooks';

import { IUpdateTax, IPostTaxResponse } from '../models/taxes.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates an existing tax
 * 
 * @param {IUpdateTax} tax the form data
 * 
 * @returns {IPostTaxResponse} the api response | error
 */
const updateTaxes = async (tax: IUpdateTax): Promise<IPostTaxResponse> => {
  try {
    const { userId } = useAuth()!;

    const modelData = JSON.stringify({
      wpID: userId,
      taxID: tax.taxId,
      taxName: tax.name,
      taxAmount: tax.amount,
      taxType: tax.type,
      partnerID: tax.partnerId,
      partnerName: tax.partnerName
    });

    const { data } = await awsApiInstance.put(`/taxes/${tax.taxId}`, modelData );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating tax');
    throw(error);
  }
}

export default updateTaxes;